"use client"

import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu"
import { useProduct } from "@/contexts/product-context"
import {
  STUDENT_EXAM_LIVE_BAND_OPTIONS,
  STUDENT_EXAM_TABLE_OPTIONS,
  studentExamDashboardStateSummary,
  useStudentExamDashboardState,
  type StudentExamLiveBandCount,
  type StudentExamTableState,
} from "@/contexts/student-exam-dashboard-state-context"
import { examManagementProfilePrototypeMenuEnabled } from "@/lib/exam-management-profile-prototype-menu"
import { useProductAuthoringEnabled } from "@exxatdesignux/ui/components/shell"

/** Prototype My Exams dashboard states — live band count and table rows. */
export function StudentExamDashboardStateMenu() {
  const authoringEnabled = useProductAuthoringEnabled()
  const { product } = useProduct()
  const { state, setLiveBandCount, setTableState } =
    useStudentExamDashboardState()

  if (
    product !== "exxat-exam-management" ||
    !examManagementProfilePrototypeMenuEnabled(product, authoringEnabled)
  ) {
    return null
  }

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className="h-auto items-start py-2">
        <i
          className="fa-light fa-layer-group mt-0.5 shrink-0"
          aria-hidden="true"
        />
        <span className="min-w-0 flex-1 pe-1 text-start">
          <span className="block leading-snug">States</span>
          <span className="mt-0.5 block text-xs leading-snug text-muted-foreground whitespace-normal break-words">
            {studentExamDashboardStateSummary(state)}
          </span>
        </span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-60">
        <DropdownMenuLabel>Live band</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={String(state.liveBandCount)}
          onValueChange={value =>
            setLiveBandCount(Number(value) as StudentExamLiveBandCount)
          }
        >
          {STUDENT_EXAM_LIVE_BAND_OPTIONS.map(option => (
            <DropdownMenuRadioItem
              key={option.value}
              value={String(option.value)}
            >
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>

        <DropdownMenuSeparator />

        <DropdownMenuLabel>Table</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={state.table}
          onValueChange={value => setTableState(value as StudentExamTableState)}
        >
          {STUDENT_EXAM_TABLE_OPTIONS.map(option => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
